<div class="basis-3xl mt-8 mb-8">

  <div class="m-y-8"><div class="flex justify-between mt-4">
    <button class="button outline " (click)="togglePanel()" >
      <img class="inline align-sub" [ngSrc]="isOpen() ?'/icons/filter-off.svg': '/icons/filter.svg'" alt="" height="20" width="20">
      <span class="hidden md:inline ">
       {{ isOpen() ? 'Nascondi' : 'Mostra' }} Filtri
      </span>
    </button>
    @if(isOpen()) {
      <button class="button outline" (click)="resetFilters()">
        Azzera Filtri
      </button>
    }
  </div>

    @if(isOpen()) {
      <div class="flex flex-col lg:flex-row gap-4 form mt-8">
        @for(field of searchFields; track field.key) {
          <div class="w-full">
            <label>{{ field.label }}</label>

            @if(field.type === 'text') {
              <input #inputElement  [(ngModel)]="inputValues[field.key]" type="text"
                     (keyup)="onParamsChange(field.key, inputElement.value)"
                     class="form-control" [placeholder]="'Cerca per ' + field.label.toLowerCase()">
            }
            @if(field.type === 'select' && field.options) {
              <select #selectElement  [(ngModel)]="inputValues[field.key]"
                      (change)="onParamsChange(field.key, selectElement.value)"
                      class="form-select">
                @if(inputValues[field.key]==='') {
                  <option  value="" disabled selected>-- Seleziona {{ field.label }}</option>
                }
                <option value="">Vedi tutti</option>
                @for(option of field.options; track option.value) {

                  <option  [value]="option.value">

                    {{ option.label }}
                  </option>
                }

              </select>

            }



            @if(field.type === 'date') {
              <input #dateElement type="date" [(ngModel)]="inputValues[field.key]"
                     (change)="onParamsChange(field.key, dateElement.value)" class="form-control">
            }
          </div>
        }
      </div>

    }

  </div>
</div>
